import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      camsQuery: ({ camStore: { camsQuery } }) => camsQuery
    }),
  },
  data() {
    return {
      search: '',
    }
  },
  methods: {
    doSearch: function() {
      let filteredQuery = JSON.parse(JSON.stringify(this.camsQuery));
      filteredQuery.page = 1;
      filteredQuery.modelnaam = '%' + this.search + '%';
      console.log(filteredQuery);
      this.$store.commit('camStore/updateQuery', filteredQuery);
      let filterState = {
        type: 'search',
        name: this.search
      };
      this.$store.commit('camStore/updateFilterState', filterState)
      this.$store.commit('camStore/updateQuery', filteredQuery);
      this.$store.dispatch('camStore/getCams', filteredQuery);
      this.$store.commit('modalStore/setModal', false);
    },
  }
}